export const auth = {
  // Authentication
  welcome: 'Bienvenue',
  signInToAccess: 'Connectez-vous pour accéder à votre compte',
  signInToAccount: 'Connectez-vous à votre compte pour continuer',
  welcomeBack: 'Bon retour',
  enterCredentials: 'Entrez vos identifiants pour accéder à votre compte',
  login: 'Connexion',
  signup: 'Inscription',
  email: 'Email',
  password: 'Mot de passe',
  fullName: 'Nom complet',
  createAccount: 'Créer un compte',
  loginFailed: 'Échec de la connexion',
  signupFailed: 'Échec de l\'inscription',
  enterEmail: 'Entrez votre email',
  enterPassword: 'Entrez votre mot de passe',
  rememberMe: 'Se souvenir de moi',
  keepMeLoggedIn: 'Rester connecté',
  forgotPassword: 'Mot de passe oublié ?',
  signingIn: 'Connexion en cours...',
  orContinueWith: 'Ou continuer avec',
  continueWithGoogle: 'Continuer avec Google',
  dontHaveAccount: 'Vous n\'avez pas de compte ?',
  alreadyHaveAccount: 'Vous avez déjà un compte ?',
  signInHere: 'Connectez-vous ici',
  signIn: 'Se connecter',
  
  // Signup
  joinKiraCar: 'Rejoindre KiraCar',
  createYourAccount: 'Créer votre compte',
  chooseYourPath: 'Choisissez votre voie et commencez votre voyage avec la meilleure plateforme de location de voitures',
  almostThere: 'Nous y sommes presque ! Configurons votre compte {{role}}',
  customer: 'Client',
  agency: 'Agence',
  admin: 'Administrateur',
  allRoles: 'Tous les rôles',
  customerRoleTitle: 'Je veux louer des voitures',
  customerAccount: 'Compte Client',
  customerRoleDescription: 'Parcourez et réservez des voitures fantastiques auprès d\'agences vérifiées',
  customerDescription: 'Parcourez et réservez des voitures incroyables auprès d\'agences vérifiées',
  browseThousandsCars: 'Parcourir des milliers de voitures',
  instantBooking: 'Réservation instantanée',
  securePayments: 'Paiements sécurisés',
  agencyRoleTitle: 'Je veux louer mes voitures',
  agencyAccount: 'Compte Agence',
  agencyRoleDescription: 'Listez votre flotte et développez votre entreprise de location',
  agencyDescription: 'Listez votre flotte et développez votre entreprise de location',
  listUnlimitedCars: 'Lister des voitures illimitées',
  manageBookings: 'Gérer les réservations',
  analyticsDashboard: 'Tableau de bord analytique',
  revenueTracking: 'Suivi des revenus',
  startRentingToday: 'Commencez à louer des voitures fantastiques aujourd\'hui',
  growYourBusiness: 'Développez votre entreprise avec nous',
  change: 'Changer',
  enterFullName: 'Entrez votre nom complet',
  enterPhone: 'Entrez votre numéro de téléphone',
  createPassword: 'Créez un mot de passe fort',
  confirmPassword: 'Confirmer le mot de passe',
  confirmYourPassword: 'Confirmez votre mot de passe',
  creatingAccount: 'Création du compte...',
  createMyAccount: 'Créer mon compte',
  getStarted: 'Commencer',
  accountCreated: 'Compte créé !',
  accountCreatedSuccess: 'Compte créé avec succès ! Veuillez vérifier votre email pour confirmer votre compte.',
  checkYourEmailForVerification: 'Veuillez vérifier votre email pour confirmer votre compte.',
  thankYouForJoining: 'Merci de nous avoir rejoint ! Nous avons envoyé un email de vérification dans votre boîte de réception. Veuillez cliquer sur le lien dans l\'email pour activer votre compte.',
  agencyCreatedSuccess: 'Agence créée avec succès ! Bienvenue chez KiraCar.',
  
  // Account Types
  selected: 'Sélectionné',
  selectAccountType: 'Sélectionner le type de compte',
  completeRegistration: 'Compléter l\'inscription',
  chooseAccountType: 'Choisissez votre type de compte pour commencer',
  fillYourInformation: 'Remplissez vos informations pour compléter l\'inscription',
  backToAccountChoice: 'Retour au choix du compte',
  emailSentTo: 'Email envoyé à',
  agencySetupAfterVerification: 'Vous pouvez configurer votre agence après la vérification email.',
  continueToSignIn: 'Continuer vers la connexion',
  
  // Form fields
  phone: 'Téléphone',
  
  // Forgot Password
  forgotPasswordTitle: 'Mot de passe oublié ?',
  forgotPasswordSubtitle: 'Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe',
  sendResetLink: 'Envoyer le lien de réinitialisation',
  sendingResetLink: 'Envoi du lien...',
  rememberPassword: 'Vous vous souvenez de votre mot de passe ?',
  backToLogin: 'Retour à la connexion',
  resetLinkSent: 'Lien de réinitialisation envoyé à votre email',
  checkEmailForReset: 'Veuillez vérifier votre email pour les instructions de réinitialisation du mot de passe',
  checkSpamFolder: 'Si vous ne voyez pas l\'email, vérifiez votre dossier spam ou réessayez avec une autre adresse email.',

  // Reset Password
  resetYourPassword: 'Réinitialiser votre mot de passe',
  enterNewPassword: 'Entrez votre nouveau mot de passe ci-dessous',
  newPassword: 'Nouveau mot de passe',
  enterNewPasswordPlaceholder: 'Entrez le nouveau mot de passe',
  confirmNewPassword: 'Confirmer le nouveau mot de passe',
  confirmNewPasswordPlaceholder: 'Confirmez le nouveau mot de passe',
  updatePassword: 'Mettre à jour le mot de passe',
  updatingPassword: 'Mise à jour du mot de passe...',
  passwordResetSuccessfully: 'Mot de passe réinitialisé avec succès',
  passwordUpdatedRedirecting: 'Votre mot de passe a été mis à jour. Redirection vers la connexion...',
  canUseNewPassword: 'Vous pouvez maintenant utiliser votre nouveau mot de passe pour vous connecter à votre compte.',

  // Email Confirmation Page
  emailConfirmationRequired: 'Confirmation d\'email requise',
  emailConfirmationInstructions: 'Pour terminer l\'inscription de votre agence, veuillez :',
  emailConfirmationStep1: 'Vérifier votre boîte de réception pour un message de confirmation',
  emailConfirmationStep2: 'Cliquer sur le lien de confirmation dans l\'email',
  emailConfirmationStep3: 'Revenir ici pour terminer la configuration de votre agence',
  emailConfirmationHelp: 'Vous ne voyez pas l\'email ? Vérifiez votre dossier spam ou essayez de rafraîchir après confirmation.',
  iveConfirmedMyEmail: 'J\'ai confirmé mon email',
  checking: 'Vérification...',

  // Agency Setup Page
  verifyingYourAccount: 'Vérification de votre compte',
  pleaseWaitWhileChecking: 'Veuillez patienter pendant que nous vérifions le statut de votre compte...',
  authenticationRequired: 'Authentification requise',
  needToBeSignedIn: 'Vous devez être connecté pour configurer votre agence. Veuillez vous connecter avec votre compte confirmé.',
  accessDenied: 'Accès refusé',
  onlyAccessibleToAgency: 'Cette page n\'est accessible qu\'aux utilisateurs d\'agence. Veuillez vous inscrire en tant qu\'agence pour accéder à cette fonctionnalité.',
  signUpAsAgency: 'S\'inscrire en tant qu\'agence',
  agencyAlreadySetUp: 'Agence déjà configurée',
  agencyAccountConfigured: 'Votre compte d\'agence est déjà configuré. Vous pouvez accéder directement à votre tableau de bord.',
  goToDashboard: 'Aller au tableau de bord',
  setupRequired: 'Configuration requise',
  failedToVerifyAccount: 'Échec de la vérification du statut de votre compte.',

  // Agency Registration Form
  pleaseSignInToContinue: 'Veuillez vous connecter pour continuer l\'inscription de l\'agence.',
  authCheckFailed: 'Échec de la vérification d\'authentification. Veuillez réessayer.',
  authFailed: 'Échec d\'authentification. Vous devrez peut-être vous reconnecter.',
  pleaseSelectValidImage: 'Veuillez sélectionner un fichier image valide',
  pleaseFillAllRequired: 'Veuillez remplir tous les champs obligatoires',
  failedToCreateAgency: 'Échec de la création de l\'agence. Veuillez réessayer.',
  enterAgencyName: 'Entrez le nom de votre agence',
  briefDescription: 'Brève description de votre entreprise de location de voitures...',
  backToSignup: 'Retour à l\'inscription',
  previous: 'Précédent',
  confirmClearProgress: 'Êtes-vous sûr de vouloir revenir en arrière ? Votre progression sera sauvegardée et vous pourrez continuer plus tard.',
  autoSaved: 'Sauvegarde automatique',

  // Agency Registration Form - Step Content
  agencyInformation: 'Informations de l\'agence',
  letsSetupAgencyProfile: 'Configurons le profil de votre agence de location',
  stepOfFour: 'Étape {{step}} sur 4',
  percentComplete: '{{percent}}% Terminé',
  settingUpSession: 'Configuration de votre session...',
  pleaseWaitPreparing: 'Veuillez patienter pendant que nous préparons votre inscription d\'agence.',
  
  // Step 1 - Basic Information
  agencyName: 'Nom de l\'agence',
  businessEmail: 'Email professionnel',
  businessPhone: 'Téléphone professionnel',
  businessDescription: 'Description de l\'entreprise',
  website: 'Site web',
  websiteOptional: 'Site web (Optionnel)',
  
  // Step 2 - Location Information
  streetAddress: 'Adresse',
  city: 'Ville',
  country: 'Pays',
  agencyLogo: 'Logo de l\'agence',
  agencyLogoOptional: 'Logo de l\'agence (Optionnel)',
  uploadAgencyLogo: 'Téléchargez le logo de votre agence (Max 5MB)',
  chooseFile: 'Choisir un fichier',
  selectCountry: 'Sélectionner un pays',
  
  // Step 3 - Business Settings
  currency: 'Devise',
  taxRate: 'Taux de taxe (%)',
  operatingHours: 'Heures d\'ouverture',
  openingTime: 'Heure d\'ouverture',
  closingTime: 'Heure de fermeture',
  openAlways: 'Ouvert 24h/24 - 7j/7',
  openAlwaysDescription: 'Votre agence est ouverte en continu, 24 heures sur 24 et 7 jours sur 7',
  openAllDay: 'Ouvert 24h/24',
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',
  closed: 'Fermé',
  to: 'à',
  
  // Step 4 - Review
  location: 'Localisation',
  businessSettings: 'Paramètres commerciaux',
  name: 'Nom',
  description: 'Description',
  
  // Navigation
  next: 'Suivant',
  createAgency: 'Créer l\'agence',
  creatingAgency: 'Création de l\'agence...',
  
  // Placeholders
  businessEmailPlaceholder: 'email@entreprise.com',
  businessPhonePlaceholder: '+212 5XX-XX-XX-XX',
  websitePlaceholder: 'https://www.votresite.com',
  streetAddressPlaceholder: '123 Rue Principal',
  cityPlaceholder: 'Paris',
  cityAutoFilled: 'La ville est automatiquement remplie lorsque vous sélectionnez une adresse',
  taxRatePlaceholder: '0.0',
  
  // Validation messages
  pleaseFillAllFields: 'Veuillez remplir tous les champs requis',
  logoFileSizeTooLarge: 'La taille du fichier logo doit être inférieure à 5MB',

  // Error messages
  emailNotConfirmed: 'Email non confirmé. Veuillez vérifier votre email et cliquer sur le lien de vérification.',
  invalidCredentials: 'Email ou mot de passe invalide. Veuillez réessayer.',
  accountNotFound: 'Compte non trouvé. Veuillez vérifier votre email ou vous inscrire.',
  passwordTooWeak: 'Le mot de passe doit contenir au moins 6 caractères.',
  emailAlreadyExists: 'Un compte avec cet email existe déjà.',
  unexpectedError: 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
  fillAllFields: 'Veuillez remplir tous les champs obligatoires.',
  passwordsDoNotMatch: 'Les mots de passe ne correspondent pas.',
  invalidEmail: 'Veuillez entrer une adresse email valide.',
  passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
  invalidExpiredLink: 'Lien invalide ou expiré. Veuillez en demander un nouveau.',
  unexpectedErrorTryAgain: 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
  checkingResetLink: 'Vérification du lien de réinitialisation...',
  processingRecoveryLink: 'Traitement du lien de récupération, veuillez patienter...',
  
  // Login specific messages
  loginSuccess: 'Connexion réussie ! Redirection...',
  loginError: 'Échec de la connexion. Veuillez vérifier vos identifiants et réessayer.',
  loginTimeout: 'Délai de connexion dépassé. Veuillez vérifier votre connexion internet et réessayer.',
  slowConnection: 'La connexion est lente, veuillez patienter...',
  initializing: 'Initialisation de l\'application...',
  retry: 'Réessayer',
  proceedAnyway: 'Continuer quand même',
  orSignUp: 'Ou s\'inscrire',
  
  // Account linking messages
  accountExistsSignIn: 'Un compte avec cet email existe déjà. Veuillez vous connecter à la place.',
  googleAccountSignIn: 'Cet email est associé à un compte Google. Veuillez vous connecter avec Google ou créer un mot de passe pour ce compte.',
  accountLinkingFailed: 'Échec de la liaison du compte. Veuillez essayer de vous connecter avec Google ou contacter le support.',
  
  // Dashboard
  signOut: 'Se déconnecter',
  
  // Email verification check
  iveVerifiedMyEmail: 'J\'ai vérifié mon email',
  emailNotYetVerified: 'Email non vérifié. Veuillez cliquer sur le lien dans votre email avant de continuer.',
  emailVerifiedSuccessfully: 'Email vérifié avec succès! Complétez maintenant la configuration de votre agence.',
  errorDuringVerification: 'Erreur lors de la vérification. Veuillez réessayer.',
  agencyConfigurationTitle: 'Configuration d\'agence',
  agencyConfigurationMessage: 'Vous devez d\'abord vérifier votre email en cliquant sur le lien envoyé. Après vérification, utilisez le bouton ci-dessous pour accéder à la configuration de votre agence.',
  accountCreatedSuccessTitle: 'Compte créé avec succès !',
  checkEmailToActivate: 'Vérifiez votre email pour activer votre compte',
  verificationEmailSent: 'Email de vérification envoyé',
  verificationEmailSentTo: 'Nous avons envoyé un email de vérification à :',
  nextSteps: 'Étapes suivantes :',
  openEmailInbox: 'Ouvrez votre boîte email',
  lookForKiraCarEmail: 'Cherchez l\'email de KiraCar',
  clickVerificationLink: 'Cliquez sur le lien de vérification',
  accountWillBeActivated: 'Votre compte sera activé automatiquement',
  dontSeeEmail: 'Vous ne voyez pas l\'email ? Vérifiez votre dossier spam ou courrier indésirable.',
  createAnotherAccount: 'Créer un autre compte',
  
  // Email verification page
  emailVerificationRequired: 'Vérification d\'email requise',
  pleaseVerifyYourEmail: 'Veuillez vérifier votre email pour vous connecter',
  checkYourEmailToVerify: 'Vérifiez votre email pour valider votre compte',
  verifyEmailToLogin: 'Vérifiez votre email pour continuer la connexion',
  verifyEmailBeforeLogin: 'Veuillez vérifier votre adresse email avant de pouvoir vous connecter à votre compte.',
  clickLinkInEmail: 'Cliquez sur le lien de vérification dans votre email',
  checkSpamIfNotFound: 'Vous ne le voyez pas ? Vérifiez vos spams',
  returnHereToCheckVerification: 'Revenez ici pour vérifier la validation',
  resendVerificationEmail: 'Renvoyer l\'email de vérification',
  resending: 'Envoi en cours...',
  resendIn: 'Renvoyer dans {{seconds}} secondes',
  verificationEmailResent: 'Email de vérification renvoyé ! Vérifiez votre boîte de réception.',
  
  // Email confirmed page
  emailConfirmedSuccessfully: 'Email confirmé avec succès !',
  accountActivatedSuccessfully: 'Votre compte a été activé avec succès',
  readyToSetupAgency: 'Vous êtes maintenant prêt à configurer votre agence',
  welcomeToKiraCarPlatform: 'Bienvenue sur la plateforme KiraCar',
  nextStepAgencySetup: 'Prochaine étape : Configuration de l\'agence',
  nextStepExplore: 'Prochaine étape : Explorer KiraCar',
  setupAgencyDetails: 'Configurez les détails de votre agence et commencez à gérer vos véhicules',
  discoverOurVehicles: 'Découvrez notre large gamme de véhicules disponibles à la location',
  setupMyAgency: 'Configurer mon agence',
  exploreKiraCar: 'Explorer KiraCar',
  welcomeToKiraCar: 'Bienvenue chez KiraCar !',
  preparingYourAccount: 'Préparation de votre compte...',
  profileNotFound: 'Configuration du compte incomplète. Veuillez contacter le support.',
  goToHome: 'Aller à l\'accueil',
  
  // Booking Authentication
  signInToBook: 'Se connecter pour réserver',
  signInToBookDescription: 'Veuillez vous connecter pour continuer votre réservation de voiture',
  createAccountToBook: 'Créer un compte pour réserver',
  createAccountToBookDescription: 'Créez un compte pour finaliser votre réservation de voiture',
  signupSuccess: 'Compte créé avec succès !',
  checkEmailForVerification: 'Veuillez vérifier votre email pour valider votre compte.',
  backToAccountType: 'Retour au type de compte',
  signUp: 'S\'inscrire',

  // Unauthorized access
  unauthorized: {
    title: 'Accès Refusé',
    requiresAccount: 'Ce tableau de bord nécessite un compte avec le rôle suivant :',
    currentlyLoggedAs: 'Vous êtes actuellement connecté en tant que :',
    loginDifferentAccount: 'Se connecter avec un autre compte',
    signOutAndLogin: 'Se déconnecter et se connecter',
    loginWithCorrectAccount: 'Se connecter avec le bon compte',
    backToHome: 'Retour à l\'accueil',
    needHelp: 'Besoin d\'aide ?',
    contactSupport: 'Contacter le support'
  },
  
  // User roles
  roles: {
    admin: 'Administrateur',
    agency: 'Agence',
    customer: 'Client',
    adminDescription: 'Accès et gestion complète du système',
    agencyDescription: 'Gérer les véhicules, réservations et clients',
    customerDescription: 'Parcourir et réserver des véhicules'
  },
  
  signingOut: 'Déconnexion...',
  backToHome: 'Retour à l\'accueil',
  
  // Auth Callback
  signingYouIn: 'Connexion en cours...',
  pleaseWaitWhileWeSignYouIn: 'Veuillez patienter pendant que nous vous connectons et vous redirigeons vers votre tableau de bord',
  
  // Top Bar Links
  imAClient: "Je suis un Client",
  imAnAgency: "Je suis une Agence"
}; 